import { Edit02Icon } from '@/components/icons/Edit02Icon';
import {
  SlideToolbar,
  SlideToolbarButton,
} from '@/modules/slideEditor/SlideToolbar';
import { LuminaryThemeProvider } from '@/styles/themes/LuminaryThemeProvider';

interface EntityDiagramChartHoverToolbarProps {
  /** Opens the full-screen entity-diagram editor. */
  onEdit: () => void;
}

/**
 * Diagram-level hover toolbar for the presentation entity diagram, shown while
 * the diagram is hovered (and no editable tile is).
 *
 * Clicking "Edit diagram" opens the existing full-screen
 * `EditEntityDiagramTrowser` (tile layout / icon / emphasis editor); the slide
 * refetches the presentation on close so it reflects the freshly-saved layout.
 *
 * Mirrors the estate-waterfall `EstateWaterfallChartHoverToolbar`.
 */
export function EntityDiagramChartHoverToolbar({
  onEdit,
}: EntityDiagramChartHoverToolbarProps) {
  return (
    <LuminaryThemeProvider>
      <SlideToolbar>
        <SlideToolbarButton
          variant="transparent"
          startIcon={Edit02Icon}
          onClick={onEdit}
        >
          Edit diagram
        </SlideToolbarButton>
      </SlideToolbar>
    </LuminaryThemeProvider>
  );
}
